<template>
  <div id="content">
    <partnerSummary></partnerSummary>
    <partnerUser></partnerUser>
    <partnerCodeChild v-if="user_code"></partnerCodeChild>
  </div>
</template>

<script>

import partnerCodeChild from '@/components/partner/partner-code-child'
import partnerSummary from '@/components/partner/partner-summary'
import partnerUser from '@/components/partner/partner-user'

export default {
  name: "partner",
  components: {
    partnerCodeChild,
    partnerSummary,
    partnerUser
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
  computed: {

    user_code() {
      return this.$store.getters['partner/user_code'];
    },

  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partner/partner.vue